import { motion } from "framer-motion";

export default function Footer() {
  return (
    <footer id="footer" data-testid="footer-section" className="bg-[color:var(--bg-dark)] text-[color:var(--text-inverse)] pt-24 md:pt-32 pb-8 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-8 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-5">
            <p className="font-mono text-xs uppercase tracking-[0.28em] opacity-70 mb-6">Contacto</p>
            <ul className="space-y-3 text-lg">
              <li><a href="mailto:dentainhoa@gmail.com" data-testid="footer-email" className="hover:text-[color:var(--accent)] transition-colors">dentainhoa@gmail.com</a></li>
              <li><a href="tel:+34641712904" data-testid="footer-phone" className="hover:text-[color:var(--accent)] transition-colors">+34 641 712 904</a></li>
              <li><a href="https://www.instagram.com/dentainhoa/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="hover:text-[color:var(--accent)] transition-colors">@dentainhoa · Instagram</a></li>
              <li className="opacity-70">Lun – Sáb · 09:00 — 21:00</li>
            </ul>
          </div>
          <div className="col-span-6 md:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.28em] opacity-70 mb-6">Zona</p>
            <ul className="space-y-2 opacity-90">
              <li>Todas las áreas de Madrid</li>
              <li>Centro · Norte · Sur · Este · Oeste</li>
              <li>Área metropolitana</li>
              <li>Desplazamiento sin coste añadido</li>
            </ul>
          </div>
          <div className="col-span-6 md:col-span-4">
            <p className="font-mono text-xs uppercase tracking-[0.28em] opacity-70 mb-6">Menú</p>
            <ul className="space-y-2 opacity-90">
              <li><a href="#manifiesto" className="hover:text-[color:var(--accent)]">Manifiesto</a></li>
              <li><a href="#servicios" className="hover:text-[color:var(--accent)]">Servicios</a></li>
              <li><a href="#trabajo" className="hover:text-[color:var(--accent)]">El Trabajo</a></li>
              <li><a href="#cita" className="hover:text-[color:var(--accent)]">Reservar cita</a></li>
            </ul>
          </div>
        </div>

        <motion.h2
          initial={{ y: 80 }}
          whileInView={{ y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
          className="font-heading italic text-[22vw] md:text-[18vw] leading-[0.82] tracking-tighter whitespace-nowrap select-none"
          data-testid="footer-wordmark"
        >
          Dentainhoa.
        </motion.h2>

        <div className="mt-16 pt-8 border-t border-white/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-mono text-xs uppercase tracking-widest opacity-70">
          <span>© 2026 Dentainhoa · Todos los derechos reservados</span>
          <div className="flex flex-wrap gap-4">
            <a href="/aviso-legal" className="hover:text-[color:var(--accent)]" data-testid="footer-aviso-legal">Aviso legal</a>
            <a href="/privacidad" className="hover:text-[color:var(--accent)]" data-testid="footer-privacidad">Privacidad</a>
            <a href="/cookies" className="hover:text-[color:var(--accent)]" data-testid="footer-cookies">Cookies</a>
          </div>
          <span>Madrid, España · Higienista colegiada</span>
        </div>
      </div>
    </footer>
  );
}
